import useWindowSize from "@/helpers/useWindowSize";
import styles from "./SearchBlock.module.scss";
import { useAppSelector } from "store/store";
import { sampleFilteredListSelector } from "store/slices/samplesSlice";
import { SamplesSearchInput } from "./SamplesSearchInput";

export const SearchBlock = () => {
  const { width } = useWindowSize();
  const isTablet = width <= 992 && width > 576;
  const list = useAppSelector(sampleFilteredListSelector);

  return (
    <div className={styles.wrapper}>
      <div className={styles.text}>
        Examples shown:
        <span className={styles.count}>{list.length}</span>
      </div>
      {!isTablet && <SamplesSearchInput className={styles.searchInput} />}
    </div>
  );
};
